import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, MailCheck, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
    const { language } = useLanguage();
    const el = language === 'el';
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
        } catch (error) {
            toast.error(error.response?.data?.detail || (el ? 'Κάτι πήγε λάθος' : 'Something went wrong'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card" data-testid="forgot-password-page">
                <div className="auth-logo">
                    <Link to="/">
                        <img
                            src="https://customer-assets-agu9un31.emergentagent.net/job_fleet-ops-62/artifacts/sxi4lya9_%CE%91%CE%BD%CF%89%CC%81%CE%BD%CF%85%CE%BC%CE%BF%20%CF%83%CF%87%CE%B5%CC%81%CE%B4%CE%B9%CE%BF.webp"
                            alt="Cofleet"
                            style={{ width: '200px', height: 'auto' }}
                            className="object-contain mx-auto mb-4 hover:opacity-80 transition-opacity"
                        />
                    </Link>
                </div>

                {sent ? (
                    <div className="text-center space-y-4" data-testid="forgot-password-sent">
                        <div className="w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mx-auto">
                            <MailCheck className="w-7 h-7 text-green-600" />
                        </div>
                        <h1 className="text-xl font-semibold text-slate-800">
                            {el ? 'Ελέγξτε το email σας' : 'Check your email'}
                        </h1>
                        <p className="text-sm text-slate-500">
                            {el
                                ? 'Αν το email υπάρχει στο σύστημα, στείλαμε σύνδεσμο επαναφοράς. Ο σύνδεσμος λήγει σε 60 λεπτά.'
                                : 'If the email exists, we sent a reset link. The link expires in 60 minutes.'}
                        </p>
                        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#1B7EB5] hover:text-[#58A6B4] transition-colors">
                            <ArrowLeft className="w-4 h-4" />
                            {el ? 'Επιστροφή στη σύνδεση' : 'Back to sign in'}
                        </Link>
                    </div>
                ) : (
                    <>
                        <p className="auth-subtitle text-center">
                            {el
                                ? 'Δώστε το email σας και θα λάβετε σύνδεσμο επαναφοράς κωδικού'
                                : 'Enter your email and we will send you a reset link'}
                        </p>
                        <form onSubmit={handleSubmit} className="space-y-4 mt-6">
                            <div className="form-group">
                                <Label htmlFor="email" className="form-label">Email</Label>
                                <Input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="name@company.com"
                                    className="bg-white border-slate-300 text-slate-900"
                                    required
                                    data-testid="forgot-email-input"
                                />
                            </div>
                            <Button
                                type="submit"
                                className="w-full btn-primary h-11"
                                disabled={loading}
                                data-testid="forgot-submit-btn"
                            >
                                {loading
                                    ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />{el ? 'Αποστολή...' : 'Sending...'}</>
                                    : (el ? 'Αποστολή συνδέσμου' : 'Send reset link')}
                            </Button>
                        </form>
                        <div className="mt-6 text-center">
                            <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#1B7EB5] hover:text-[#58A6B4] transition-colors" data-testid="back-to-login-link">
                                <ArrowLeft className="w-4 h-4" />
                                {el ? 'Επιστροφή στη σύνδεση' : 'Back to sign in'}
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
